<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
           <h6 class="primary--text">{{ bid.customerName }}</h6>
          </v-card-title>
          <img :src="bid.picture" height="150">
          <v-card-text>
            <div class="info--text">{{ bid.dateCreated | date }} - {{ bid.totalPrice }}</div>
            <div>{{ bid.description }}</div>
          </v-card-text>
        <v-tabs
          v-model="active"
          color="cyan"
          dark
          slider-color="yellow"
        >
        <v-tab key="bid_options"   ripple>Offerte Opties</v-tab>
        <v-tab key="bid_overview"  ripple>Offerte Overzicht</v-tab>
        <v-tab-item key="bid_options">
           Hier komt een overzicht van de verschillende opties van deze offerte.
           <v-switch></v-switch><h1> Optie A</h1>
           <table>
            <th><td>Aantal</td><td>Type</td><td>Eenheidsprijs</td><td>Prijs</td></th>
            <tr><td>10</td><td>Panelen 270W</td><td>380€</td><td>3800€</td></tr>
            <tr><td>1</td><td>Omvormer SMA</td><td>1200€</td><td>1200€</td></tr>
            <tr><td></td><td>BTW</td><td>21% </td><td>1050€</td></tr>
            <tr><td></td><td>Totaal</td><td></td><td>6050€</td></tr>
           </table>
            <v-switch></v-switch><h1> Optie B</h1>
           <table>
            <th><td>Aantal</td><td>Type</td><td>Eenheidsprijs</td><td>Prijs</td></th>
            <tr><td>10</td><td>Panelen 270W</td><td>380€</td><td>3800€</td></tr>
            <tr><td>1</td><td>Omvormer SAJ</td><td>1200€</td><td>800</td></tr>
            <tr><td></td><td>BTW</td><td>21% </td><td>966€</td></tr>
            <tr><td></td><td>Totaal</td><td></td><td>5566€</td></tr>
           </table>
        </v-tab-item>
        <v-tab-item key="bid_overview">
           <v-data-table
            :headers="attributeSummaryHeaders"
            :items="attributeSummaryData"
            class="elevation-1"
            :pagination.sync="pagination"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.label }}</td>
              <td class="text-xs-left">{{ props.item.value }}</td>
            </template>
          </v-data-table>
        </v-tab-item>
        
        </v-tabs>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="primary">Copy</v-btn>
            <v-btn class="primary" flat :to="'/offerte/new/' + bid.id">Edit</v-btn>
            <v-btn class="primary"
              @click="onSendBid()">Verzenden</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    props: ['id'],
    data() {
      return{
          
          rowsPerPageItems: [25,50,100],
          pagination: {
              rowsPerPage: 25
          },
          attributeSummaryHeaders : [
             { text: 'Vraag',    value: 'label' },
             { text: 'Antwoord', value: 'value' }
          ]
      }
    },
    computed: {
      bid() {
        return this.$store.getters.loadedOfferte(this.id)
      },
      questions(){
        return this.$store.getters.questions;
      },
      attributeSummaryData(){
        var records = [];
        for(var targetField in this.questions )
        {
          const q = this.questions[targetField];
          //only the none picture answers
          if(q.type !== 'picture')
          {
            
            var rec = { 
              label  : q.label,
              value  : this.bid[q.targetField]
            }
            if(q.type == 'multi')
            {
              //comma separated list
              rec.value = '';
              const answerArray = this.bid[q.targetField];
              for(var answer in answerArray)
              {
                if(rec.value !== '' ) { rec.value += ' ,  '}
                rec.value += answerArray[answer];
              }
             
            }
            records.push(rec);
          }
        }
        return records;
      }
    },
    methods :
    {
      onSendBid(){
               
                const payload = {
                    bid : {...this.bid,dateChanged : new Date(),sendEmail:true},
                    router : this.$router
                }
                payload.sendEmail = true;
                this.$store.dispatch('createOfferte',payload);
            }
    }
  }
</script>